<ngx-spinner
    *ngIf="!routerLoading"
    bdColor="rgba(7,7,7,0.61)"
    color="#3498db"
    type="ball-scale-pulse"
    size="medium"
>
    <p style="color: white">{{ "loading.loading" | translate }}</p>
</ngx-spinner>

<!-- Router loader - shows while router-outlet is loading -->
<div *ngIf="routerLoading" class="router-loader">
    <div class="loader-container">
        <div class="loader-spinner"></div>
        <p>{{ "loading.router-preparing" | translate }}</p>
    </div>
</div>
<router-outlet></router-outlet>